// 简体中文
export default {
  ai: {
    menuStyle: 'AI风格预设',
    menuQuota: 'AI额度管理',
    menuUsage: 'AI用量统计',
    addStyle: '新增风格',
    editStyle: '编辑风格',
    styleName: '风格名称',
    styleNameEn: '英文名',
    stylePrompt: '风格提示词',
    previewUrl: '预览/参考图',
    builtIn: '内置',
    custom: '自定义',
    type: '类型',
    belongCompany: '归属商户',
    sortOrder: '排序',
    copyStyle: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    confirmDeleteStyle: '确认删除该风格？',
    builtInNoEdit: '内置风格不可编辑，请先复制为自定义风格',
    promptRequired: '请输入风格提示词',
    nameRequired: '请输入风格名称',
    uploadPreview: '上传预览图',
    promptPlaceholder: '例如：国风水墨，严格保持人物面部特征不变',
    allTypes: '全部类型',
    recharge: '充值',
    rechargeTitle: '额度充值',
    newRecharge: '新增充值',
    companyCode: '商户编码',
    companyName: '商户名称',
    quotaStatus: '开通状态',
    quotaTotal: '总额度(张)',
    quotaUsed: '已用(张)',
    quotaRemain: '剩余(张)',
    unitPrice: '结算单价(元/张)',
    currency: '币种',
    updateTime: '更新时间',
    addQuota: '充值张数',
    enabled: '已开通',
    disabled: '未开通',
    openAi: '开通',
    closeAi: '关闭',
    rechargeSuccess: '充值成功',
    rechargeFailed: '充值失败',
    companyCodeRequired: '请输入商户编码',
    addQuotaRequired: '请输入充值张数',
    confirmOpen: '确认开通该商户AI能力？',
    confirmClose: '确认关闭该商户AI能力？',
    operateSuccess: '操作成功',
    dateRange: '统计区间',
    invokeCount: '调用次数',
    successCount: '成功次数',
    generatedNum: '生成张数',
    costAmount: '成本合计(元)',
    trend: '按天趋势',
    byCompany: '按商户',
    byDevice: '按设备',
    deviceCode: '设备编码',
    day: '日期',
    last7: '近7天',
    last30: '近30天',
    menuRecord: 'AI调用记录',
    deviceName: '设备名称',
    deviceCount: '分配设备数',
    unlimited: '不限',
    assignDevices: '分配设备',
    assignTips: '未选择任何设备时表示不限制，所有设备均可使用该风格',
    selectDevices: '请选择设备',
    companyRequired: '请选择商户',
    selectCompany: '请选择商户',
    orderCode: '订单号',
    status: '状态',
    allStatus: '全部状态',
    success: '成功',
    failed: '失败',
    model: '模型',
    size: '尺寸',
    requestId: '请求ID',
    costMs: '耗时(ms)',
    createTime: '调用时间',
    errMsg: '错误信息',
    sourceImages: '原图',
    resultImages: '生成图',
    viewDetail: '查看详情',
    recordDetail: '调用详情',
    noImage: '无图片',
    capability: '能力',
    styleId: '风格ID',
    productType: '玩法类型',
    selectProductType: '请选择玩法类型',
    printSpec: '打印规格',
    selectPrintSpec: '请选择打印规格',
    pixelSize: '像素尺寸',
    sizeTier: '成本档位',
    selectSizeTier: '请选择成本档位',
    retryPrice: '重抽单价(元)',
    recommendedPeople: '推荐人数'
  },
  login: {
    username: '用户名',
    password: '密码',
    login: '登录',
    inputUsername: '请输入用户名',
    inputPassword: '请输入密码'
  },
  autoLogin: {
    loading: '正在以商户账号登录，请稍候...',
    missingParams: '自动登录参数缺失，请重新从商户列表发起',
    failed: '商户账号自动登录失败，请检查账号或密码'
  },
  forgotPwd: {
    forgot: '忘记密码？',
    title: '重置密码',
    email: '邮箱',
    inputEmail: '请输入注册邮箱',
    invalidEmail: '邮箱格式不正确',
    code: '验证码',
    inputCode: '请输入邮箱验证码',
    sendCode: '获取验证码',
    newPassword: '新密码',
    inputNewPassword: '请输入新密码（至少6位）',
    confirmPassword: '确认新密码',
    inputConfirmPassword: '请再次输入新密码',
    passwordTooShort: '密码至少6位',
    passwordNotMatch: '两次输入的密码不一致',
    submit: '确认重置',
    cancel: '取消',
    sendSuccess: '验证码已发送，请查收邮件',
    sendFail: '验证码发送失败，请稍后重试',
    resetSuccess: '密码重置成功，请重新登录',
    resetFail: '密码重置失败，请稍后重试'
  },
  employee: {
    inputAccount: '请输入账号',
    inputName: '请输入姓名',
    inputMobile: '请输入手机号',
    selectRole: '请选择角色',
    allRoles: '全部角色',
    allStatus: '全部状态',
    collapse: '收起',
    expand: '展开',
    employeeCount: '员工数量 ：',
    addEmployee: '＋添加员工',
    account: '帐号',
    name: '姓名',
    gender: '性别',
    role: '角色',
    company: '所属商户',
    creator: '添加人',
    createTime: '添加时间',
    devicePermission: '设备权限',
    deviceCountUnit: '{count} 台设备',
    viewAllDevices: '查看全部设备',
    disableAccount: '停用',
    resetPassword: '重置密码',
    assignDevices: '分配设备',
    tip: '提示',
    deleteConfirm: '删除账户后，该账户无法再登录系统是否确认删除？',
    employeeName: '员工姓名：',
    usernameLabel: '用户名：',
    currentPermission: '当前权限：',
    assignedDevices: '已分配 {count} 台设备',
    selectDevice: '选择设备：',
    selectDevicePlaceholder: '请选择设备',
    deviceHint: '不选择任何设备表示该员工可以查看公司所有设备',
    selectAtLeastOneDevice: '请至少选择 1 台设备',
    assignSuccess: '设备分配成功',
    assignFailed: '分配失败',
    loadDeviceInfoFailed: '加载设备信息失败',
    loadDeviceListFailed: '加载设备列表失败',
    disableConfirmTitle: '确定停用该员工账号吗?',
    disableConfirmContent: '停用后该员工将无法登录系统',
    disableSuccess: '停用成功',
    enableConfirmTitle: '确定启用该员工账号吗?',
    enableConfirmContent: '启用后该员工将可以登录系统',
    enableSuccess: '启用成功',
    resetPwdConfirmTitle: '确定重置该员工密码吗?',
    resetPwdConfirmContent: '重置后密码将恢复为默认密码（JTphoto0515）',
    resetPwdSuccess: '重置密码成功',
    addSuccess: '新增员工成功',
    updateSuccess: '修改员工成功',
    addTitle: '新增员工',
    editTitle: '修改员工',
    accountLabel: '账号：',
    nameLabel: '姓名：',
    passwordLabel: '密码：',
    defaultPwdTip: '不填则使用默认密码 JTphoto0515',
    defaultPwdPlaceholder: '不填则使用默认密码',
    emailLabel: '邮箱：',
    emailInvalid: '请输入正确的邮箱',
    maxLength50: '长度不能超过50个字符',
    mobileLabel: '手机：',
    mobileInvalid: '请输入正确的手机号',
    roleSetting: '角色设置：',
    statusSetting: '状态设置：',
    selectStatus: '请选择状态',
    genderSetting: '性别设置：',
    selectGender: '请选择性别',
    deptSetting: '部门设置：',
    remarkLabel: '备注：',
    remarkPlaceholder: '请输入备注信息',
    submit: '提交',
    save: '保存',
    usernameRequired: '用户名不能为空',
    usernameMax20: '用户名不能超过20个字符',
    usernameMin4: '用户名不能少于4个字符',
    usernameExists: '抱歉，该用户名已存在',
    mobileRequired: '手机号不能为空！',
    nameRequired: '姓名不能为空！',
    roleRequired: '角色设置不能为空！'
  },
  homepage: {
    totalIP: '总IP',
    todayfc: '今日分成收入',
    weekQOQ: '周环比',
    dayQOQ: '日环比',
    todayCompanyIncome: '今日商户收入',
    todayPlatformIncome: '今日平台总收入',
    todayFlow: '今日客流数',
    todayOrder: '今日订单',
    todayRefundOrder: '今日退款订单',
    machineOnlineCount: '机器在线数',
    machineOfflineCount: '机器未在线数',
    totalPlatformIncome: '平台总收入',
    totalOperatorIncome: '运营商总分成',
    totalCompanyIncome: '商户总收入',
    totalFlow: '客总流数',
    totalOrder: '订单总数',
    totalRefundOrder: '总退款订单',
    usage: '使用量',
    incomeAmount: '收入金额',
    flow: '客流量',
    orderCount: '订单数',
    todayIncome: '今日收入',
    lastLoginTime: '上次登录时间',
    canWithdrawalIncome: '可提现收入',
    goodMorning: '早上好',
    goodForenoon: '上午好',
    goodNoon: '中午好',
    goodAfternoon: '下午好',
    goodEvening: '晚上好',
    welcome1: '喝杯咖啡休息下吧☕',
    welcome2: '要不要和朋友打局LOL',
    welcome3: '要不要和朋友打局王者荣耀',
    welcome4: '几天没见又更好看了呢😍',
    welcome5: '今天又写了几个Bug🐞呢',
    welcome6: '今天在群里吹水了吗',
    welcome7: '今天吃了什么好吃的呢',
    welcome8: '今天您微笑了吗😊',
    welcome9: '今天帮助别人解决问题了吗',
    welcome10: '准备吃些什么呢',
    welcome11: '周末要不要去看电影？',
    dateRange: '{start} ~ {end}',
    withdraw: '提现',
    avatarAlt: '头像',
    noDept: '暂无部门',
    noRole: '暂无角色',
    firstVisit: '第一次访问系统',
    todayIp: '今日IP数',
    todayVisit: '今日访问',
    totalVisit: '总访问量',
    dateQuery: '日期查询',
    selectDate: '请选择日期',
    today: '今天',
    lowPaperTitle: '设备相纸不足提醒',
    lowPaperTip: '以下设备相纸剩余不足{count}张，请及时补充相纸，以免影响设备正常使用！',
    lowPaperDeviceName: '设备名称',
    lowPaperDeviceCode: '设备编号',
    lowPaperCount: '相纸数量',
    lowPaperClose: '关闭'
  },
  device: {
    companyManage: '商户管理',
    deviceManage: '机器管理',
    totalDevices: '目前机器数量',
    all: '全部',
    online: '在线中',
    offline: '已离线',
    updating: '更新中',
    versionUpdate: '更新版本',
    export: '导出',
    batchUpdate: '批量更新',
    unbind: '解绑',
    bind: '绑定',
    companyName: '商户名称',
    deviceCode: '机器编码',
    appVersion: '版本号',
    sn: '设备型号',
    uiName: '机器UI使用',
    uiGroupName: 'UI组',
    photoTime: '拍摄时间',
    intervalTime: '拍摄间隔时间',
    pagerNum: '纸张数量',
    goodsNum: '机器产品',
    filterNum: '滤镜',
    address: '机器所在地址',
    orderCount: '当台机器订单',
    vendorActiveStatus: '收钱吧激活状态',
    actived: '已激活',
    unactive: '未激活',
    active: '激活',
    vendorActiveTime: '收钱吧激活时间',
    vendorTerminalSn: '收钱吧终端号',
    vendorTerminalKey: '收钱吧终端密钥',
    vendorTerminalUpdateTime: '终端最新签到时间',
    operation: '操作',
    command: '指令已下发成功',
    reset: '重启系统',
    restartApp: '重启APP',
    showMenu: '显示菜单',
    hideMenu: '隐藏菜单',
    reportLog: '上报日志',
    isSupperCoins: '是否支持投币',
    unbinded: '已解绑',
    binded: '已绑定',
    bindStatus: '绑定状态',
    lastestOnlineTime: '最后在线时间',
    macAddress: 'MAC地址',
    resolution: '分辨率',
    deviceSN: '设备SN',
    deviceVersion: '设备版本',
    deviceKey: '设备KEY',
    deviceName: '设备名称',
    deviceIMEI: '设备IMEI',
    activationCode: '机台编码',
    leyaoyaoCode: '乐摇摇设备码',
    electronicPhoto: '电子照片',
    scanDownload: '扫描下载',
    sendFriend: '加好友发送',
    templateImage: '预览图',
    working:'工作中',
    workStatus:'工作状态',
    showName: '设备展示名称',
    remark: '备注',
    thumbnail: '缩略图',
    remoteCode: '远程码',
    belongCategory: '所属类别',
    allMerchants: '全部商户',
    assign: '分配',
    viewOrders: '查看订单',
    selectBindMerchant: '请选择绑定的商户',
    pendingVendorActive: '待激活收钱吧',
    vendorActivationCode: '收钱吧激活码',
    vendorActivationCodePlaceholder: '请输入收钱吧激活码',
    vendorActivationCodeRequired: '请填写收钱吧激活码',
    merchantName: '商户名称',
    selectMerchantName: '请选择商户名称',
    assignDeviceToSub: '分配设备给下属商户',
    deviceLabel: '设备：',
    targetMerchant: '目标商户',
    selectSubMerchant: '请选择下属三级商户',
    noSubMerchant: '当前没有下属商户，请先创建三级商户',
    selectTargetMerchant: '请选择目标商户',
    assignSuccess: '设备分配成功',
    assignFailed: '设备分配失败',
    selectDeviceToUpdate: '请选择要更新的机器！最少选择一项',
    setupSuccess: '机器设置成功',
    updateUI: '更新UI',
    updateApp: '更新APP',
    updateConfig: '更新配置',
    shellExec: 'Shell 命令执行',
    shellCommand: 'Shell 命令',
    shellCommandPlaceholder: '请输入要执行的 Shell 命令，例如：ls -la /tmp',
    sendShellCommand: '发送 Shell 命令',
    dangerousConfirmTip: '危险命令将需要二次确认',
    notifiedUpdateUI: '已通知设备更新UI',
    notifiedUpdateApp: '已通知设备更新APP',
    notifiedUpdateConfig: '已通知设备更新配置',
    inputShellCommand: '请输入 Shell 命令',
    dangerousWarningTitle: '⚠️ 危险操作警告',
    dangerousWarningContent: '您正在执行危险命令，可能导致设备异常！是否继续执行？',
    confirmExecute: '确定执行',
    commandSent: '命令已发送，请等待设备执行',
    sendFailed: '发送失败',
    networkError: '网络错误，请稍后重试',
    confirmUnbind: '解绑后设备将与商户解除关联，确定要解绑该设备吗？',
    copyCompanyName: '复制商户名称',
    copyDeviceCode: '复制设备编码',
    copyActiveCode: '复制激活码',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    pcInfo: 'PC机信息',
    pcName: '计算机名',
    pcOs: '操作系统',
    pcIp: '内网IP',
    pcMac: 'MAC地址',
    pcCpu: 'CPU',
    pcCpuUsage: 'CPU使用率',
    pcMemory: '内存(已用/总量)',
    pcMemoryUsage: '内存使用率',
    pcTemperature: '温度',
    pcDisk: '系统盘(可用/总量)',
    pcDefaultPrinter: '默认打印机',
    pcNoPrinter: '无',
    pcReportTime: '上报时间'
  },
  setting: {
    navbarColor: '导航栏颜色',
    themeColor: '主题颜色',
    navbarPosition: '导航栏位置',
    fixedTopRail: '固定顶栏',
    fixedSidebar: '固定侧边栏',
    multiTabMode: '多页标签模式',
    currency: '货币符号 / 代码',
    currencyPlaceholder: '可选择或直接输入，如 ¥ / USD / SAR',
    languageSwitching: '语言切换',
    userCenter: '个人中心',
    updatePassword: '密码修改',
    customSystem: '系统定制',
    logout: '退出登录',
    updateCache: '更新缓存',
    refreshCacheSuccess: '缓存更新成功',
    refreshCacheFailed: '缓存更新失败'
  },
  common: {
    confirm: '确认',
    cancel: '取消',
    saveSetting: '保存设置',
    languageChanged: '语言切换成功',
    timezoneChanged: '时区切换成功',
    search: '搜索',
    pleaseInputContent: '请输入搜索的内容',
    export: '导出',
    default: '默认',
    item: '款',
    view: '查看',
    setup: '设置',
    status: '状态',
    showTotal: '显示 {start} ~ {end} 条记录，共 {total} 条记录',
    yes: '是',
    no: '否',
    info: '信息',
    sequenceNumber: '序号',
    creationTime: '创建时间',
    operation: '操作',
    defaultSort: '排序号',
    type: '内置',
    edit: '编辑',
    delete: '删除',
    deleteSuccess: '删除成功',
    editSuccess: '编辑成功',
    updateSuccess: '修改成功',
    connectionError: '服务器连接异常，请稍后在尝试！',
    reset:'重置',
    allCategory:'全部分类',
    exportExecl:'导出 Excel',
    exportError:'导出失败！',
    selectDataFirst:'请选择需要导出的贴纸！',
    query:'查询',
    add:'添加',
    batchAdd:'批量添加',
    noData:'暂无数据',
    deleteFailed:'删除失败',
    prompt:'温馨提示',
    back:'返回',
    loadError:'加载失败',
    isDefault:'是否默认',
    setDefault:'设置默认',
    cancelDefault:'取消默认',
    batchEdit:'批量编辑',
    uploadImg:'上传照片',
    uploadImgSuccess:'图片上传成功',
    uploadImgFailed:'上传失败',
    uploadImgTips1:'只能上传JPG、JPEG、GIF、PNG格式的图片~',
    uploadImgTips2:'超过30M限制，不允许上传~',
    addSuccess:'添加成功',
    all:'全部',
    deleteError:'删除失败',
    deleteNoData:'请选择需要删除的数据',
    disable:'禁用',
    enable:'启用',
    exportSuccess:'导出成功',
    operateError:'操作失败，请重试',
    searchError:'查询失败',
    uploadError:'上传失败',
    selectAll:'全选',
    totalRecords:'共 {total} 条记录',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeOthers: '关闭其它'
  },
  template: {
    merchantManagement: '商户管理',
    uiManagement: 'UI管理',
    newConfig: '新增相框',
    editFrame: '编辑相框',
    editConfig: '编辑配置',
    top: '顶部',
    bottom: '底部',
    builtIn: '内置',
    nonBuiltIn: '非内置',
    uiConfigName: 'UI名称',
    background: '背景',
    wechatOfficialAccount: '公众号',
    title: '标题',
    banner: '上下banner条',
    creationTime: '创建时间',
    indicatorColor: '指示条配色',
    type: '类型',
    appliedMachines: '应用机器数',
    freamName: '相框名称',
    editSuccess: '编辑ui成功',
    deletePrompt: '删除这个UI配置，该用户将无法使用该UI配置是否确认删除？',
    matchProduct: '所属产品',
    selectProduct: '请选择产品',
    templateFilePng: '模板文件png',
    maxFileSize: '最大只支持10M的图片',
    addUploadImage: '添加上传图片',
    addHistoryImage: '选择历史图片 ',
    previewImage: "预览图",
    cuttingImage: '裁切图',
    groupPhotoFrame: '是否合拍相框',
    groupPhotoYes: '合拍相框',
    groupPhotoNo: '非合拍相框',
    groupPhotoLensSetting: '合拍镜头明细设置',
    groupPhotoConfigured: '已配置合拍图',
    groupPhotoNotSet: '未设置合拍图',
    buttonNormal: "常规按钮",
    buttonPressed: "按钮按下",
    buttonNormalExample: "常规按钮示例",
    buttonPressedExample: "按钮按下示例",
    reuseTemplateFile: "复用模板文件",
    reuseNormalButton: "复用常规按钮",
    reuseAllTemplateFiles: "全部复用模板文件",
    productType:'产品类型',
    //贴纸管理
    stickerPreview: "贴纸图片",
    stickerCode:"贴纸编码",
    stickerCategory:'所属分类',
    stickerType:'类型',
    stickerSize:'尺寸',
    stickerStatus:'状态',
    stickerOperation:'操作',
    stickerName:'贴纸名称',
    addSticker:'新增贴纸',
    editSticker: '编辑贴纸',
    StickerIndexNum: '排序号',
    onlyImage: '只能上传JPG、JPEG、GIF、PNG格式的图片~',
    selectCategory: '请选择分类',
    selectStatus: '请选择状态',
    selectType: '请选择类型',
    stickerFileSize: '文件大小',
    staticSticker:'静态贴图',
    gifSticker:'GIF 动图',
    videoSticker:'视频贴纸',
    frameGroup: '相框组'
  },
  sticker:{
    stickerPreview: "贴纸图片",
    stickerCode:"贴纸编码",
    stickerCategory:'所属分类',
    stickerType:'类型',
    stickerSize:'尺寸',
    stickerStatus:'状态',
    stickerOperation:'操作',
    stickerName:'贴纸名称',
    stickerImage:'贴纸图片',
    stickerThumbnail:'缩略图',
    stickerWidth:'宽度 (像素)',
    stickerHeight:'高度 (像素)',
    stickerDuration:'文件时长 (秒)',
    stickerFileSize:'文件大小',
    StickerIndexNum:'排序号',
    stickerTags:'标签关键字',
    stickerDescription:'描述',
    statusTips:'请选择状态',
    typeTips:'请选择类型',
    categoryTips:'请选择分类',
    editSticker:'编辑贴纸',
    imgPreview:'图片预览',
    codeCheckResultErr:'❌ 该编码已存在，请更换',
    codeCheckResultOk:'✅ 编码可用',
    inputCodeTips:'选填。终端按编码后缀区分贴纸类型（如 ST2D），建议使用大写英文、数字、下划线',
    addSticker:'添加贴纸',

    //贴纸分类
    categoryIcon:'分类图标',
    categoryName:'分类名称',
    categoryCode:'分类编码',
    categoryIconPlaceholder:'请输入图标URL地址',
    addCategory:'添加分类',
    editCategory:'编辑分类',
    //贴纸分组
    groupNewAdd:'新增分组',
    groupEdit:'编辑分组',
    groupName:'分组名称',
    groupCode:'分组编码',
    groupIcon:'分组图标',
    hasSticker:'包含贴纸数',
    groupCodePlaceholder:'请输入分组编码(大写英文)',
    groupNamePlaceholder:'请输入分组名称',
    groupDescriptionPHR:'请输入分组描述',
    controllerSticker:'管理贴纸',
    selectSticker:'选择贴纸',
    addFailed:'添加失败',
    addSuccess:'添加成功',
    deleteFailed:'删除失败',
    deleteSuccess:'删除成功',
    fileDurationDesc:'视频/GIF专用，可选',
    fileDurationTips:'仅视频/GIF贴纸需要填写',
    fileSizeDesc:'上传后自动填充',
    fileSizeExample:'例如: 51200',
    heightExample:'例如: 200',
    widthExample:'例如: 200',
    selectAtLeastOne:'请至少选择一个贴纸',
    stickerCodeDesc:'全局唯一标识，建议使用 STICKER_XXX 格式',
    stickerCodeTips:'请输入贴纸编码(唯一)',
    stickerImageSize:'建议尺寸: 200x200 像素，支持 PNG、JPG 格式',
    thumbnail:'缩略图',
    uploadStickerImage:'请上传贴纸图片',
    inputStickerName:'请输入贴纸名称',
    codeFormatTips:'建议使用 STICKER_XXX 格式',
    codeExists:'该贴纸编码已存在，请更换',
    codeValidateFailed:'校验失败',
    codeValidateError:'校验编码失败，请重试',
    codeFormatError:'编码格式错误，建议使用 STICKER_XXX 格式',
    codeCheckFailedRetry:'校验失败，请重试',
    tagsPlaceholder:'多个标签用逗号分隔，例如：开心，表情，笑脸',
    tagsDesc:'用于搜索和分类',
    descPlaceholder:'请输入贴纸描述',
    uploadImage:'上传图片',
    uploadThumbnail:'上传缩略图',
    reuseStickerImage: '复用贴纸图片',
    reuseStickerImageTip: '缩略图将直接使用贴纸图片，无需单独上传',
    thumbnailOptional:'可选，系统可自动生成',
    thumbnailUploadSuccess:'缩略图上传成功',
    selectCategoryAttr:'请选择分类属性',
    completeFormInfo:'请完善表单必填信息',
    sortOrderPlaceholder:'数字越小越靠前',
    categoryCodePlaceholder:'请输入分类编码(大写英文)',
    categoryCodeDesc:'唯一标识，建议使用大写英文，如：HOT、CUTE',
    inputCategoryName:'请输入分类名称',
    inputCategoryCode:'请输入分类编码',
    categoryCodePatternMsg:'请输入大写英文，可包含下划线',
    categoryCodeExists:'该分类编码已存在，请更换',
    uploadCategoryIcon:'请上传贴纸图标',
    sortOrderMustNumber:'排序号必须为数字',
    categoryDescPlaceholder:'请输入分类描述',
    confirmDeleteCategory:'确认删除该分类吗？',
    exportDeveloping:'导出功能开发中...',
    confirmDeleteGroup:'确定要删除该分组吗？',
    selectGroupToDelete:'请选择要删除的分组',
    inputGroupName:'请输入分组名称',
    groupNameTooLong:'分组名称长度不能超过50个字符',
    inputGroupCode:'请输入分组编码',
    groupCodeFormatMsg:'分组编码只能包含大写英文、数字、下划线',
    groupCodeTooLong:'分组编码长度不能超过50个字符',
    groupCodeInvalidOrExists:'分组编码格式错误或已存在，请检查',
    uploadGroupIcon:'请上传分组图标',
    sortOrderInvalid:'请输入有效的排序号（大于等于0的数字）',
    selectStatusEnableDisable:'请选择状态（启用/禁用）',
    codeCheckErrorTips:'⚠️ 编码校验失败，请稍后重试',
    editFailed:'编辑失败',
    operationFailedRetry:'操作失败，请重试',
    inputStickerCode:'请输入贴纸编码',
    apiException:'接口异常',
    selectStickerType:'请选择贴纸类型',

    confirmDeleteSticker:'确定要删除该贴纸吗？',
    stickerSlected:'已选中贴纸',
    sourceType:'来源',
    allSourceType:'全部来源',
    sourcePlatform:'平台',
    sourceMerchant:'商户自建',
    copyToMerchant:'复制到商户',
    copyToMerchantTitle:'复制分组给商户',
    copyToMerchantTip:'将平台分组及其下贴纸复制一份给指定商户（生成商户自有副本）',
    targetCompanyCode:'目标商户编码',
    inputTargetCompanyCode:'请输入目标商户编码',
    copyGroupSuccess:'复制分组成功',
    copyGroupFailed:'复制分组失败',
    copy:'复制',
    manage:'管理',
    originalGroupName:'原分组名称',
    newGroupName:'新分组名称',
    inputNewGroupName:'请输入新分组名称',
    selectCompany:'请选择商户',
    targetCompany:'目标商户',
    belongCompany:'所属商户',

    //批量上传贴纸
    batchUpload:'批量上传',
    batchUploadTitle:'批量上传贴纸',
    batchBaseName:'基础名称',
    batchBaseNamePlaceholder:'请输入贴纸基础名称',
    batchBaseNameTip:'每张贴纸名称 = 基础名称 + 两位序号（01、02 … 99），按文件名升序编号',
    batchDragText:'点击或拖拽图片到此区域上传',
    batchDragHint:'支持一次选中多个文件，仅图片（jpg/png/gif/webp/bmp），单张≤1MB，一次最多 99 张',
    batchSelectedCount:'已上传 {count} 张',
    batchClearAll:'清空',
    batchOnlyImage:'仅支持图片格式（jpg/png/gif/webp/bmp）',
    batchSizeLimit:'单张图片不能超过 1MB',
    batchMaxCount:'一次最多上传 99 张贴纸',
    batchNoSticker:'请先上传至少一张贴纸',
    batchUploadPending:'仍有图片上传中，请稍候',
    batchSubmitSuccess:'批量上传成功',
    batchSubmitFailed:'批量上传失败',
  },
  filter: {
    filterName: '滤镜名称',
    addFilter: '＋添加滤镜',
    addFilterTitle: '添加滤镜',
    editFilterTitle: '编辑滤镜',
    filterPreview: '滤镜预览',
    filterOriginalImage: '滤镜原图',
    filterResourceFile: '滤镜资源文件',
    belongCompany: '所属商户',
    allMerchants: '全部商户',
    type: '类型',
    builtIn: '内置',
    nonBuiltIn: '非内置',
    appliedMachines: '应用机器数',
    defaultSort: '排序',
    serialNo: '序列号',
    batchCopy: '批量复制',
    copy: '复制',
    tip: '提示',
    deletePrompt: '删除这个滤镜，机器将无法使用该滤镜是否确认删除？',
    editFilterSuccess: '编辑滤镜成功',
    loadCompanyFailed: '加载商户列表失败',
    copyFilterSuccess: '复制滤镜成功',
    copyFilterFailed: '复制滤镜失败',
    batchCopySuccess: '批量复制滤镜成功',
    batchCopyFailed: '批量复制滤镜失败',
    selectFilterFirst: '请先勾选要复制的滤镜',
    copyToMerchantTitle: '复制滤镜给商户',
    batchCopyTitle: '批量复制滤镜给商户',
    originalFilterName: '原滤镜名称',
    newFilterName: '新滤镜名称',
    inputNewFilterName: '请输入新的滤镜名称',
    targetMerchant: '目标商户',
    selectCompany: '请选择商户',
    selectedFilters: '已选滤镜',
    nameSuffix: '统一名称后缀',
    inputNameSuffix: '请输入统一名称后缀',
    nameSuffixTip: '新滤镜名称 = 原滤镜名称 + 该后缀',
    inputFilterName: '请输入滤镜名称',
    inputName: '请输入名称',
    selectTypeMsg: '请选择类型',
    inputDefaultSort: '请输入默认排序',
    colorMatrix: '颜色矩阵',
    whitening: '美白',
    smoothing: '磨皮',
    bigEye: '大眼',
    thinFace: '瘦脸',
    smallFace: '小脸',
    forehead: '额头',
    cheekbone: '颧骨',
    nose: '鼻子',
    mouth: '嘴巴',
    chin: '下巴',
    intensity: '滤镜强度',
    sampleFullColor: '示例全彩：',
    colorModeExample: '彩照模式示例图',
    pngFilterExample: 'PNG滤镜原图示例图',
    anyFormatMax10M: '任意格式，不超过10M',
    colorModeNormal: '彩照模式-常规：',
    colorModePressed: '彩照模式-按下：',
    reuseAllSampleColor: '全部复用示例全彩',
    addUploadImage: '添加上传图片',
    uploadFile: '上传文件',
    reupload: '重新上传',
    submit: '提交',
    btnNormalRequired: '彩照模式-常规图不能为空 ！',
    imageUrlRequired: '示例全彩图不能为空 ！',
    filterPngRequired: '滤镜原图不能为空 ！',
    btnSelectedRequired: '彩照模式-按下图不能为空 ！',
    exceed10M: '超过10M限制，不允许上传~',
    uploadFailed: '上传失败'
  },
  goods: {
    productName: '产品名称',
    newProductName: '新产品名称',
    productCode: '产品编号',
    preview: '预览',
    width: '宽',
    height: '高',
    imageCount: '镜头数',
    frameTop: '距顶部高度',
    frameBottom: '距底部高度',
    frameLeft: '距左边宽度',
    frameRight: '距右边宽度',
    frameCount: '相框数量',
    printMode: '打印模式',
    orientation: '打印方向',
    price: '单价',
    companyPrice: '商户定价',
    increasePrice: '加印价',
    defaultIncreasePrice: '默认加印价',
    companyIncreasePrice: '商户加印价',
    type: '类型',
    deviceCount: '应用机器数',
    operation: '操作',
    tip: '提示',
    confirmDelete: '删除后，机器将无法选择使用该产品，是否删除？',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    search: '搜索',
    addProduct: '＋添加产品',
    pleaseInputContent: '请输入搜索的内容',
    sequenceNumber: '序号',
    printingMode: '打印模式',
    oneCopyInDuplicate: '一式一份',
    inDuplicate: '一式两份',
    vertical: '垂直(竖)',
    horizontal: '水平(横)',
    riceConfirmation: '请输入正确的价格！只能大于或等于0.01！',
    cannotEditBuiltIn: '内置产品不允许编辑，只有超级管理员可以编辑',
    cannotDeleteBuiltIn: '内置产品不允许删除，只有超级管理员可以删除',
    copy: '复制',
    copyProduct: '复制产品',
    originalProductName: '原产品名称',
    inputProductName: '请输入新产品名称',
    selectCompany: '请选择商户',
    copySuccess: '复制产品成功',
    selectProductType: '请选择产品类别',
    allProductTypes: '全部产品类别',
    frameManage: '相框管理',
    productManage: '产品管理',
    copyFrames: '同时复制相框',
    copyFramesHint: '同时复制该产品下的所有相框',
    copyAsBuiltin: '复制为内置产品',
    copyAsBuiltinHint: '勾选后无需选择商户，直接复制给平台',
    batchCopyProduct: '批量复制产品',
    selectedProducts: '已选产品',
    nameSuffix: '产品统一后缀',
    inputNameSuffix: '请输入产品统一后缀',
    nameSuffixTip: '所有复制出的新产品名称将统一追加该后缀',
    batchCopyPriceTip: '单价与加印价默认取第一个选中产品，将应用到所有复制出的新产品',
    batchCopySuccess: '批量复制产品成功',
    selectProductsFirst: '请先选择要复制的产品',
    orderNum: '排序',
    belongCategory: '所属类别',
    belongCompany: '所属商户',
    subCategory: '小分类',
    groupName: '分组名'
  },
  order: {
    orderManagement: '订单管理',
    orderList: '订单列表',
    all: '全部',
    paid: '已支付',
    completed: '已完成',
    unpaid: '未支付',
    refunded: '已退款',
    timeout: '已超时',
    canceled: '已取消',
    paying: '支付中',
    unclose: '未关闭',
    closed: '已关闭',
    toBeReversed: '待撤销',
    reversed: '已撤销',
    evaluated: '已评价',
    exception: '异常',
    unknown: '未知',
    payFail: '支付失败',
    notRefund: 'N/A',
    applyRefund: '申请退单',
    refundInProgress: '退款中',
    agreeRefund: '同意退单',
    refuseRefund: '拒绝退单',
    refundedStatus: '退款完成',
    refundFail: '退款失败',
    cancelRefund: '撤销退单',
    photo: '拍照',
    print: '打印',
    remotePrint: '远程打印',
    orderNumber: '订单编号',
    merchant: '对应商户',
    deviceNumber: '机器编号',
    payMode: '支付方式',
    orderType: '订单类型',
    paymentStatus: '支付状态',
    totalPrice: '总价',
    createTime: '创建时间',
    payTime: '支付时间',
    quantity: '数量',
    unitPrice: '单价',
    discountAmount: '优惠金额',
    refundStatus: '退款状态',
    refundReason: '订单备注',
    operation: '操作',
    export: '导出',
    orderCount: '订单数量',
    searchPlaceholder: '请输入搜索的内容',
    agree: '同意退款',
    refuse: '拒绝退款',
    refund: '退款',
    viewPhoto: '查看照片',
    gifImage: '动图',
    confirmAgreeRefund: '确定同意此订单的退款申请?',
    agreeRefundContent: '当您点击确定按钮后，这个订单将完成退款申请',
    agreeRefundSuccess: '订单同意退款成功',
    confirmRefuseRefund: '确定拒绝此订单的退款申请?',
    refuseRefundContent: '当您点击确定按钮后，这个订单将拒绝退款申请',
    refuseRefundSuccess: '订单拒绝退款成功',
    deviceName:'机器名称',
    printTip: '提示',
    printConfirm: '是否需要打印订单号：{orderCode} 订单信息？',
    viewRemotePhotos: '查看照片',
    remotePrintPhotos: '远程打印照片',
    uploadPhotos: '上传照片',
    uploadPrint: '上传打印',
    noPhotos: '暂无照片',
    viewPhotos: '照片详情',
    photoDetail: '照片详情',
    compositePhotos: '合成照片',
    originalPhotos: '原始照片',
    noCompositePhotos: '暂无合成照片',
    noOriginalPhotos: '暂无原始照片',
    frameId: '相框ID',
    noGifImage: '暂无动图',
    downloadAllAsZip: '打包下载全部图片',
    noPhotosToDownload: '暂无可下载的图片',
    downloadSuccess: '下载成功！',
    downloadFailed: '下载失败，请重试',
    copyOrderCode: '复制订单编码',
    allMerchants: '全部商户',
    allDevices: '全部设备',
    allPayModes: '全部支付方式',
    payWeixin: '微信',
    payAlipay: '支付宝',
    payShouqianba: '收钱吧',
    payDougong: '斗拱汇付天下',
    payYunguanjia: '云管家',
    payLeyaoyao: '乐摇摇',
    payCoins: '投币',
    payFree: '免费',
    payCoupon: '兑换码',
    payDai: '代币',
    payCoin: '硬币',
    payCash: '现金',
    payCard: '刷卡',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    delete: '删除',
    batchDelete: '批量删除',
    deleteConfirm: '确定要删除订单 {orderCode} 吗？将同时删除订单详情及OSS上的照片（原图、合成图、GIF），删除后不可恢复！',
    batchDeleteConfirm: '确定要删除选中的 {count} 个订单吗？将同时删除订单详情及OSS上的照片，删除后不可恢复！',
    deleteSuccess: '删除成功!',
    deleteFailed: '删除失败!',
    selectDeleteFirst: '请先选择要删除的订单!'
  },
  coupon: {
    all: '全部',
    notActivated: '未激活',
    activated: '已激活',
    used: '已使用',
    cancelled: '已作废',
    searchPlaceholder: '请输入券码/商户名称/设备名称',
    export: '导出',
    generateCoupon: '生成优惠券',
    qrCode: '二维码',
    noQrCode: '无',
    clickToPreview: '点击预览大图',
    couponQrCode: '优惠券二维码',
    clickToDownload: '点击图片可直接下载',
    confirmCouponInfo: '请确认优惠券信息',
    merchantName: '商户名称',
    selectMerchant: '请选择商户名称',
    deviceObject: '应用设备',
    selectDeviceFirst: '请先选择设备',
    couponQuantity: '优惠券数量',
    inputCouponQuantity: '请输入优惠券数量',
    activateCoupon: '是否激活优惠券',
    yes: '是',
    no: '否',
    activate: '激活',
    cancel: '作废',
    couponId: '优惠券编号',
    merchant: '商户名称',
    deviceName: '设备名称',
    couponCode: '优惠券编码',
    status: '状态',
    createTime: '生成时间',
    operation: '操作',
    activateSuccess: '激活成功!',
    activateFailed: '激活失败!',
    cancelSuccess: '作废成功!',
    cancelFailed: '作废失败!',
    generateSuccess: '生成成功!',
    generateFailed: '生成失败!',
    generating: '优惠券生成中，请稍后...',
    maxCouponLimit: '不可一次生成超过500张优惠券!',
    generateTip: '每次最多生成500张优惠券，如需更多请分批生成，每台机器每月最多生成2000张',
    selectMerchantFirst: '请先选择商户!',
    downloadSuccess: '下载成功！',
    superCoupon: '超级优惠券',
    setSuperCoupon: '设为超级优惠券',
    setSuperCouponConfirm: '确定要将该优惠券设置为超级优惠券吗？设置后，该设备原有的超级优惠券将自动降级为普通优惠券。',
    setSuperCouponSuccess: '设置超级优惠券成功!',
    setSuperCouponFailed: '设置超级优惠券失败!',
    delete: '删除',
    batchDelete: '批量删除',
    deleteConfirm: '确定要删除该优惠券吗？删除后不可恢复！',
    batchDeleteConfirm: '确定要删除选中的 {count} 张优惠券吗？删除后不可恢复！',
    deleteSuccess: '删除成功!',
    deleteFailed: '删除失败!',
    selectDeleteFirst: '请先选择要删除的优惠券!',
    expireTime: '过期时间',
    expireTimePlaceholder: '请选择过期时间（不选则永不过期）',
    expireTimeTip: '不选择则永不过期，选择后优惠券在该时间之后不可使用',
    noExpire: '永不过期'
  },
  dashboard: {
    date: '日期',
    flow: '客流数',
    companyCount: '新增商户数',
    deviceCount: '新增机器数',
    photoCount: '拍照订单数',
    printCount: '打印订单数',
    amount: '平台总收入',
    justSumAmount: '平台分成',
    companySumAmount: '商户分成',
    lineCount: '机器在线数',
    companyName: '商户名',
    deviceCode: '机器编码',
    activeCode: '机台编码',
    deviceName: '机器名称',
    photo: '拍照订单数',
    print: '打印订单数',
    totalPrice: '平台总收入',
    timeCycle: '时间',
    defaultTimeFilter: '默认时间筛选（月）',
    month: '月',
    week: '周',
    day: '日',
    search: '搜索',
    export: '导出',
    refund: '退款',
    confirmRefund: '确定此订单申请退款?',
    refundContent: '当您点击确定按钮后，这个订单将发起退款申请',
    refundSuccess: '订单退款申请成功',
    confirmAgreeRefund: '确定同意此订单的退款申请?',
    agreeRefundContent: '当您点击确定按钮后，这个订单将完成退款申请',
    agreeRefundSuccess: '订单同意退款成功',
    confirmRefuseRefund: '确定拒绝此订单的退款申请?',
    refuseRefundContent: '当您点击确定按钮后，这个订单将拒绝退款申请',
    refuseRefundSuccess: '订单拒绝退款成功',
    timeRangeRequired: '时间范围不能为空',
    devicePlaceholder: '请选择设备',
    allDevices: '全部设备'
  },
  uiGroup:{
    uiGroupManage:'UI组管理',
    newUIGroup:'新建UI组',
    searchUIName:'搜索UI组名称...',
    resourceType:'资源类型',
    adminDefine:'Admin定义',
    merchantDefine:'商户定义',
    uiName:'UI名称',
    subPageCount:'子页面数',
    downloadPackage:'打包下载',
    onlyOneInCategoryCannotDelete:'该类别（语言+产品）仅剩一条UI组，不可删除',
    remark:'备注',
    createTime:'创建时间',
    pageManage:'页面管理',
    copy:'复制',
    copyPrompt:'确定要复制该UI组吗？',
    copySuccess:'复制成功',
    copyFail:'复制失败',
    copyUIGroup:'复制UI组',
    originalUIName:'原UI组名称',
    newUIName:'新UI组名称',
    inputNewUIName:'请输入新UI组名称',
    selectCompany:'请选择商户',
    companyName:'商户名称',
    addUIGroup:'新建UI组',
    deletePrompt:'确定要删除该UI组吗？',
    deleteSuccess:'删除成功',
    editUIGroup:'编辑UI组',
    editSuccess:'编辑成功',
    addSuccess:'新增UI组成功',
    addFail:'新增UI组失败',
    newPage: "新建页面",
    editPage: "编辑页面",
    addPage: "新增页面",
    pageName: "页面名称",
    pageKey: "页面Key",
    pageOrder: "页面顺序",
    elementCount: "元素数量",
    elementManage: "元素管理",
    pleaseInputPageName: "请输入页面名称",
    pleaseInputPageKey: "请输入页面Key",
    pleaseInputPageOrder: "请输入页面顺序",
    deletePagePrompt: "确定要删除该页面吗？删除后无法恢复！",
    addPageSuccess: "新增页面成功",
    addPageFail: "新增页面失败",
    editPageSuccess: "编辑页面成功",
    editPageFail: "编辑页面失败",
    deletePageSuccess: "删除页面成功",
    deletePageFail: "删除页面失败",
    pageKeyExists: '页面Key已存在，请更换',
    productType:'产品类别',
    elementName:'元素名称',
    elementType:'元素类型',
    allElement:'全部元素',
    editElement:'编辑元素',
    addElement:'新增元素',
    elementValue:'元素值',
    elementValueMsg:'请输入元素值',
    elementKey:'元素Key',
    elementKeyMsg:'请输入元素Key',
    elementKeyPlaceholder:'同一页面内元素Key不可重复，建议使用英文和下划线',
    elementNameMsg:'请输入元素名称',
    elementTypeMsg:'请选择元素类型',
    elementKeyError:'当前页面元素Key已存在，请更换',
    elemnetDeleteTips:'确定删除该元素？',
    batchEditElement:'批量编辑元素',
    horizontalLayout:'横向布局',
    verticalLayout:'纵向布局',
    loadingElementList:'正在加载元素列表...',
    allResourceType:'全部资源类型',
    pleaseInputUIName:'请输入UI组名称',
    pleaseSelectResourceType:'请选择资源类型',
    previewImage: '预览图',
    reupload: '重新上传',
    uploadPreviewImage: '上传预览图',
    languageType: '语言类别',
    selectLanguageType: '请选择语言类别',
    pageSize: '页面尺寸',
    pixelWH: '像素(宽×高)',
    belongCompany: '所属商户',
    cancelDefaultConfirm: '确定要取消该UI组的默认状态吗？',
    setDefaultConfirm: '确定要将该UI组设置为默认吗？',
    operateSuccess: '操作成功！',
    operateFail: '操作失败',
    onlyJpgPng: '只能上传JPG、PNG格式的图片！',
    exceed4M: '图片大小不能超过4MB！',
    uploadSuccess: '上传成功',
    uploadSuccessNoUrl: '上传成功但无法获取图片地址',
    inputImageUrlPlaceholder: '或直接输入图片地址（http/https）',
    useImageUrl: '使用该地址',
    invalidImageUrl: '请输入有效的图片地址（以 http:// 或 https:// 开头）',
    imageUrlApplied: '图片地址已应用',
    pasteTip: '提示：截图或复制图片后，可直接按 Ctrl+V/Cmd+V 粘贴上传',
    pasteUploadSuccess: '粘贴图片上传成功',
    langZhCN: '简体中文',
    langEn: '英文',
    langFr: '法文',
    langKo: '韩文',
    langZhTW: '繁体中文',
    langVi: '越南文',
    langAr: '阿拉伯文',
    langBih: '波黑文',
    langTh: '泰语',
    langDe: '德文',
    langEs: '西班牙文'
  },
  deviceSetup: {
    title: '设置机器',
    basicInfo: '机器基础信息',
    machineModelSN: '机器型号[SN]',
    inputMachineSN: '请输入机器sn码',
    machineName: '机器名称',
    inputMachineName: '请输入机器名称',
    machineCode: '机器编号',
    inputMachineCode: '请输入机器编号',
    machineAddress: '机器所在地址',
    inputMachineAddress: '请输入机器所在地址',
    activationCode: '机器编码',
    h5Url: 'H5页面地址',
    customerServicePhone: '客服电话',
    photoAccessType: '电子照片获取方式',
    selectPhotoAccessType: '请选择类型',
    paymentMode: '是否投币器模式',
    selectPaymentMode: '请选择类型',
    onlinePayment: '在线支付',
    offlineCoin: '线下投币',
    scanQRCode: '扫描二维码',
    addFriend: '加好友',
    machineSettings: '机器设置',
    uiGroupSelection: 'UI组选择',
    selectUiGroup: '请选择UI组',
    uiSelection: 'UI选择',
    searchUiName: '搜索UI名称',
    viewAll: '全部',
    viewSelected: '只看已选',
    builtIn: '内置',
    notBuiltIn: '非内置',
    productSelection: '产品选择',
    searchProductName: '搜索产品名称',
    selectAll: '全选',
    frameSelection: '边框选择',
    selectProductFirst: '请先选择产品',
    searchFrameName: '搜索边框名称',
    noProductSelected: '请先在产品选择中勾选至少一个产品，然后选择产品查看对应边框',
    noFrameData: '当前产品没有对应的边框数据',
    filterSelection: '滤镜选择',
    searchFilterName: '搜索滤镜名称',
    stickerGroup: '贴纸分组',
    searchGroupName: '搜索分组名称',
    noStickerGroupData: '暂无贴纸分组数据',
    aiStyleSelection: 'AI风格分配',
    searchAiStyleName: '搜索风格名称',
    aiStyleTip: '勾选该设备可使用的AI风格；不勾选任何风格表示不限制（可用全部可见风格）。仅AI类型设备可配置。',
    noAiStyleData: '暂无可用AI风格',
    stickersCount: '{count} 个贴纸',
    parameterSettings: '参数设置',
    photoTime: '机器拍摄时间',
    seconds: '秒',
    inputPhotoTime: '请输入机器拍摄时间',
    intervalTime: '拍摄时间间隔',
    inputIntervalTime: '拍摄时间间隔',
    paperCount: '机器打印纸张',
    sheets: '张',
    inputPaperCount: '请输入纸张数',
    paperCountRequired: '纸张数必须填写',
    cancel: '取消',
    save: '保存',
    selectAtLeastOneProduct: '请选择最少一个产品',
    selectAtLeastOneFilter: '请选择最少一个滤镜',
    paperCountMinLimit: '纸张数量不能低于50',
    serverConnectionError: '服务器连接异常，请稍后在尝试！',
    deviceThumbnail: '设备缩略图',
    modify: '修改',
    upload: '上传',
    remoteDesktopInfo: '远程桌面信息',
    remoteDesktopPlaceholder: '请输入远程桌面信息(远程码)',
    format: '格式化',
    belongCategory: '所属类别',
    selectBelongCategory: '请选择所属类别',
    onlyJpgPng: '只能上传 JPG、PNG 格式的图片~',
    exceed4M: '超过 4M 限制，不允许上传~',
    thumbnailUploadFailed: '缩略图上传失败',
    jsonFormatErrorFormat: 'JSON 格式错误，无法格式化，请检查后重试',
    jsonFormatError: 'JSON 格式错误，请检查后重试',
    searchUiGroupName: '搜索UI组名称',
    currentUsing: '当前使用',
    setCurrentUiGroup: '设置当前使用的UI组',
    selectCurrentUiGroup: '请选择当前使用的UI组',
    showName: '设备展示名称（扫二维码下载电子照片页面标题）',
    showNamePlaceholder: '用于客户扫码获取电子照片页面标题显示',
    remark: '备注说明',
    remarkPlaceholder: '管理员备注说明',
    customConfig: '自定义配置',
    customConfigPlaceholder: '请输入JSON格式的自定义配置',
    productLimitExceeded: '产品数量超出限制（最多 {max} 个），如需更多支持，请联系供应商',
    frameLimitExceeded: '产品相框数量超出限制（最多 {max} 个），如需更多支持，请联系供应商',
    filterLimitExceeded: '滤镜数量超出限制（最多 {max} 个），如需更多支持，请联系供应商',
    currentProductCount: '当前已选 {count} 个',
    currentFrameCount: '当前已选 {count} 个',
    currentFilterCount: '当前已选 {count} 个',
    parseUrl: '解析URL',
    urlEditorTitle: 'H5地址参数管理',
    urlBase: 'URL地址',
    urlParams: 'URL参数',
    paramName: '参数名',
    paramValue: '参数值',
    addParam: '添加参数',
    noParams: '暂无参数，点击“添加参数”新增',
    done: '完成',
    pasteTip: '提示：截图或复制图片后，可直接按 Ctrl+V 粘贴上传',
    pasteUploadSuccess: '粘贴上传成功',
    filterByCompany: '按商户筛选'
  },
  company: {
    deviceList: '设备列表',
    //name: '时光艺站',
    name: '焦糖映画',
    desc: '享受美好时光！',
    companyName: '商户名称',
    title: '商户管理',
    list: '商户列表',
    searchPlaceholder: '请输入搜索的内容',
    search: '搜索',
    count: '商户数量',
    addAccount: '＋添加账户',
    incoming: '进件',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    incomingQRCode: '进件二维码',
    tip: '提示',
    deleteConfirm: '删除这个商户，该商户子级也将会被删除是否确认删除？',
    maxProductsPerDevice: '每台设备最大产品数',
    maxFramesPerProduct: '每个产品最大相框数',
    maxFiltersPerDevice: '每台设备最大滤镜数',
    maxProductsPerDevicePlaceholder: '默认10个',
    maxFramesPerProductPlaceholder: '默认20个',
    maxFiltersPerDevicePlaceholder: '默认6个',
    limitConfigSection: '配置限制',
    companyInfo: '商户信息',
    linkMan: '联系人',
    contactInfo: '联系方式',
    cooperationWay: '合作方式',
    jointOperation: '联营',
    selfOperated: '自营',
    agent: '代理',
    businessStatus: '营业状态',
    operating: '运营中',
    stopped: '已停运',
    hasBackend: '是否开设后台',
    backendAccount: '后台帐号',
    backendPassword: '后台密码',
    deviceCount: '机器数量',
    orderData: '订单数据',
    companyRatio: '商户占比(%)',
    operatorRatio: '运营商占比(%)',
    companyDesc: '商户描述',
    companyAddress: '商户地址',
    openAggregatedPay: '是否开通聚合支付',
    thirdPayWay: '第三方支付方式',
    merchantId: '商户号',
    merchantType: '商户类型',
    merchantAppid: '商户Appid',
    wechatRedirectUrl: '微信支付重定向地址',
    payNotifyUrl: '支付回调地址',
    refundNotifyUrl: '退款回调地址',
    sqbMerchantCode: '商户编码(收钱吧)',
    sqbDeveloperKey: '收钱吧开发者key',
    storeActiveCode: '门店激活码',
    frontendCallbackUrl: '前端回调地址',
    merchantSecret: '商户Secret',
    unit: '个',
    merchantLevel: '商户层级',
    level2Merchant: '二级商户',
    level3Merchant: '三级商户',
    aggregatedPayMerchant: '聚合支付商',
    backendOpen: '后台开放',
    forwardIncomingPrefix: '汇来米进件_',
    qrCodeGenerateFailed: '生成二维码失败，请重试',
    invalidWebUrl: '获取的网页地址无效，请联系管理员',
    noValidWebUrl: '未获取到有效的网页地址',
    fetchDataFailed: '获取数据失败，请重试',
    browserNotSupportDownload: '您的浏览器不支持自动下载，请右键保存图片',
    downloadImageFailed: '下载图片失败，请重试',
    httpError: 'HTTP错误，状态码: {status}',
    copyCompanyName: '复制商户名称',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    loginAsMerchant: '用商户账号登录',
    loginAsMerchantNoAccount: '该商户未配置后台账号或密码，无法登录'
  },
  income: {
    totalIncome: '订单总金额',
    platformIncome: '平台分成',
    companyIncome: '商户体系收入',
    subMerchantIncome: '三级商户应得',
    parentIncome: '二级商户留存',
    orderCount: '订单数量',
    subMerchantIncomeDetail: '三级商户收入明细',
    subRatioText: '三级留存',
    subJustRatioText: '二级抽成',
    splitRatio: '分成比例',
    deviceCount: '设备数量',
    deviceCode: '设备编号',
    deviceName: '设备名称'
  },
  personal: {
    oldPassword: '旧密码',
    inputOldPassword: '请输入旧密码',
    strength: '强度：',
    passwordTip: '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
    newPassword: '新密码',
    passwordPlaceholder: '至少6位密码，区分大小写',
    confirmPassword: '再次确认',
    confirmPasswordPlaceholder: '确认密码',
    levelLow: '低',
    levelMedium: '中',
    levelStrong: '强',
    minSixChars: '请至少输入6位数的密码',
    strengthNotEnough: '密码强度不够',
    inputPassword: '请输入密码',
    passwordNotMatch: '两次密码不一致',
    oldPasswordIncorrect: '旧密码不正确',
    editProfile: '编辑资料',
    updateAvatar: '修改头像',
    avatarAlt: '头像',
    avatarUpdateSuccess: '更换头像成功',
    email: '邮箱',
    mobile: '手机',
    dept: '部门',
    gender: '性别',
    description: '描述',
    inputEmail: '请输入邮箱',
    inputMobile: '请输入手机号',
    emailInvalid: '请输入正确的邮箱',
    emailMax: '长度不能超过50个字符',
    mobileInvalid: '请输入正确的手机号',
    selectGender: '请选择性别',
    descMax: '长度不能超过100个字符',
    submit: '提交',
    selectAvatar: '选择头像',
    clickToSelect: '点击选择',
    updatingWarning: '更换头像中，请勿重复点击',
    updateAvatarFailed: '更新头像失败',
    tabHthz: '后田花子',
    tabAl: '阿里系',
    tabLm: '脸萌'
  },
  userInfo: {
    title: '用户信息',
    account: '账户：',
    role: '角色：',
    noRole: '暂无角色',
    male: '男',
    female: '女',
    confidential: '保密',
    department: '部门：',
    noDepartment: '暂无部门',
    gender: '性别：',
    phone: '电话：',
    noPhone: '暂未绑定电话',
    email: '邮箱：',
    noEmail: '暂未绑定邮箱',
    status: '状态：',
    locked: '锁定',
    valid: '有效',
    createTime: '创建时间：',
    lastLogin: '最近登录：',
    description: '描述：'
  },
  remotePrint: {
    loading: '加载中...',
    expired: '记录已过期',
    expiredDesc: '此上传记录已失效，请返回终端重新操作',
    completed: '已完成',
    completedDesc: '照片已成功提交，请在终端旁等待打印',
    submitted: '提交成功',
    submittedDesc: '照片已发送至终端，请在机器上完成后续操作',
    orderInfo: '订单信息',
    recordCode: '记录编号',
    orderCode: '订单编号',
    product: '产品名称',
    price: '单价',
    expireTime: '过期时间',
    photos: '照片',
    addPhoto: '添加照片',
    tipFormat: '仅支持 JPG/PNG 格式图片',
    tipSize: '照片将自动压缩至 1844x1200 以内(保留原比例)',
    tipExpire: '记录有效期为 5 分钟，请尽快上传',
    submit: '上传并打印',
    submitting: '提交中...',
    noRecordCode: '缺少记录编号，请扫描二维码访问',
    loadFailed: '加载失败，请稍后重试',
    invalidFormat: '仅支持 JPG/PNG 格式',
    photoLimit: '最多只能上传 {count} 张照片',
    fileTooLarge: '文件大小不能超过 10MB',
    uploadFailed: '上传失败，请重试',
    noPhotoUploaded: '请至少上传一张照片',
    submitFailed: '提交失败，请重试'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN.js